import React from "react"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import NonStretchedImage from "gatsby-theme-blank/src/components/Image/non-stretched-image"
import {
  nePasManquerItem,
  nePasManquerItemTitle,
  nePasManquerItemImg,
} from "../ne-pas-manquer.module.scss"
import PropTypes from "prop-types"
import { Title } from "./ne-pas-manquer-item-styled"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"

const NePasManquerItem = ({ nePasManquer }) => (
  <div>
    <EditButton link={"/node/" + nePasManquer.drupal_internal__nid + "/edit"} />
    <TransitionFade link={nePasManquer.path.alias}>
      <div className={nePasManquerItem}>
        <NonStretchedImage
          className={nePasManquerItemImg}
          {...nePasManquer?.relationships?.field_image_page_de_base?.localFile}
          ariaHidden={true}
        />
        <Title className={nePasManquerItemTitle}>{nePasManquer.title}</Title>
      </div>
    </TransitionFade>
  </div>
)

NePasManquerItem.propTypes = {
  nePasManquer: PropTypes.object.isRequired,
}

export default NePasManquerItem
